import React from 'react'
import './Searchfilter/Filter.css'
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { SearchFilterSide } from './Searchfilter/SearchRatingFilter';
import Pag from './Searchcards/Pag';

export default function SearchPage(props) {
  const { page } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(5000000);

  return (
    <div className='w-100 d-flex justify-content-center my-5'>
      <div className='SabcatigoryPage'>
        <SearchFilterSide id={page}></SearchFilterSide>
        <Pag page={page} maxPrice={maxPrice} minPrice={minPrice} personal={props.personal} update_p={props.update_p}></Pag>
      </div>
    </div>
  )
}
